module.exports = __webpack_public_path__ + "img/1522260345.ecd24e10.jpg";